import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Snackbars from './layout/Snackbars';
import HeaderView from './components/header';
import OrganisationGate from './gates/OrganisationGate';
import OrganisationRegisterView from './views/organisationRegister/OrganisationRegisterView';
import GlobalDashboardView from './views/globalDashboard/GlobalDashboardView';
import { mountFAQ, unmountFAQ } from './utils/tbFAQ';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const globalContextPages = ['/global-dashboard', '/register-organisation', '/access-denied'];
function setUserInfoInDOM(_ref) {
  let {
    email,
    firstName,
    lastName,
    fullName,
    id
  } = _ref;
  window.ofaEmail = email;
  window.ofaFirstName = firstName;
  window.ofaLastName = lastName;
  window.ofaUserFullName = fullName;
  window.ofaUserId = id;
}
function setOrganisationInfoInDOM(organisation) {
  window.ofaOrganisationRegistrationId = organisation?.registrationNumber;
  window.ofaOrganisationCountry = organisation?.country;
}
function App() {
  const currentLocale = useSelector(state => state.i18n.locale);
  const user = useSelector(state => state.user);
  const organisation = useSelector(state => state.organisation);
  const location = useLocation();
  React.useEffect(() => {
    if (currentLocale === 'fr') {
      mountFAQ();
    }
    return () => {
      unmountFAQ();
    };
  }, [currentLocale]);
  React.useEffect(() => {
    setOrganisationInfoInDOM(organisation);
  }, [organisation?.organisationId]);
  React.useEffect(() => {
    setUserInfoInDOM(user);
  }, [user.email, user.firstName, user.lastName, user.fullName, user.id]);
  const noLeftHeader = ['/register-organisation'].includes(location.pathname);
  let background = ' background-panda';
  if (['/global-dashboard'].includes(location.pathname)) {
    background = ' background-white';
  } else if (noLeftHeader) {
    background = ' background-white no-padding p-5';
  }
  return /*#__PURE__*/_jsx("div", {
    style: noLeftHeader ? {
      paddingLeft: 50
    } : {},
    children: /*#__PURE__*/_jsxs("div", {
      className: `main-template${background}`,
      children: [/*#__PURE__*/_jsx(Snackbars, {}), /*#__PURE__*/_jsx(HeaderView, {}), /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/register-organisation",
          component: OrganisationRegisterView
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/global-dashboard",
          component: GlobalDashboardView
        }), /*#__PURE__*/_jsx(Route, {
          component: OrganisationGate
        })]
      })]
    })
  });
}
export default App;